import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
localStorage.getItem('access_token')
const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL
}

export function* getUserSiigo(action) {
    const res = yield gaxios.request({
        url: `api/users/siigo/?identification=${action.identification}`,
        headers: {
            Authorization: localStorage.getItem('siigo_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({
            type: actions.SET_CURRENT_USER_SIIGO,
            currentUser:res.data.usuario
          });
    }
}



export default function* rootSaga() {
    yield all([
        yield takeEvery(actions.GET_USER_SIIGO_REQUEST, getUserSiigo),
    ]);
}
